import { useState, useEffect } from 'react'
import { Bell, Check, Trash2 } from 'lucide-react'
import { apiClient } from '../utils/api'

function AdminNotifications() {
  const [notifications, setNotifications] = useState<any[]>([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    fetchNotifications()
  }, [])

  const fetchNotifications = async () => {
    setLoading(true)
    try {
      const data = await apiClient.getNotifications()
      setNotifications(data.sort((a: any, b: any) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime()))
    } catch (error) {
      console.error('Failed to fetch notifications:', error)
    } finally {
      setLoading(false)
    }
  }

  const markAsRead = async (id: string) => {
    try {
      await apiClient.markNotificationAsRead(id)
      setNotifications(notifications.map((n: any) => n.id === id ? { ...n, is_read: true } : n))
    } catch (error) {
      console.error('Failed to mark as read:', error)
    }
  }

  const unreadCount = notifications.filter((n: any) => !n.is_read).length
  const readCount = notifications.filter((n: any) => n.is_read).length

  return (
    <div className="space-y-6">
      <div className="bg-[#161b22] border border-gray-800 rounded-xl p-6">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-2xl font-bold text-white flex items-center gap-2">
            <Bell size={24} />
            Notifications
          </h2>
          <div className="flex gap-4 text-sm">
            <div className="px-3 py-1 bg-blue-900/20 border border-blue-700 rounded-full text-blue-300">
              {unreadCount} Unread
            </div>
            <div className="px-3 py-1 bg-gray-700/50 border border-gray-600 rounded-full text-gray-300">
              {readCount} Read
            </div>
          </div>
        </div>

        {loading ? (
          <p className="text-gray-400">Loading notifications...</p>
        ) : notifications.length === 0 ? (
          <p className="text-gray-400">No notifications yet.</p>
        ) : (
          <div className="space-y-3">
            {notifications.map((notification) => (
              <div
                key={notification.id}
                className={`p-4 border rounded-lg transition ${
                  notification.is_read
                    ? 'bg-gray-800/50 border-gray-700'
                    : 'bg-blue-900/20 border-blue-700'
                }`}
              >
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <div className="flex items-center gap-2">
                      <p className="text-white font-semibold">Announcement</p>
                      {!notification.is_read && (
                        <span className="px-2 py-0.5 bg-blue-600 text-white text-xs font-bold rounded-full">
                          NEW
                        </span>
                      )}
                    </div>
                    <p className="text-sm text-gray-400 mt-1">
                      {new Date(notification.created_at).toLocaleString()}
                    </p>
                  </div>
                  <div className="flex gap-2">
                    {!notification.is_read && (
                      <button
                        onClick={() => markAsRead(notification.id)}
                        className="p-2 bg-blue-600 hover:bg-blue-700 rounded text-white transition"
                        title="Mark as read"
                      >
                        <Check size={16} />
                      </button>
                    )}
                    <button
                      className="p-2 bg-gray-700 hover:bg-red-900/20 hover:text-red-500 rounded text-gray-400 transition"
                      title="Delete notification"
                    >
                      <Trash2 size={16} />
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default AdminNotifications
